import React from "react";
import { Link } from "react-router-dom";
import GameCard from "./GameCard";

// Desktop-only grid. Mobile now uses the same swipeable deck
// (CardBasedMobilePicks) as /picks on both the home screen and the picks
// page, so this component no longer needs a separate mobile list rendering.
const GamesList = ({
  games,
  userPicks,
  onMakePick,
  title = "Games Next 48 Hours",
}) => {
  return (
    <>
      {/* Desktop Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">{title}</h2>
        <Link
          to="/picks"
          className="text-blue-500 hover:text-blue-700 font-medium"
        >
          View All Games
        </Link>
      </div>

      {/* Desktop Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {games.map((game) => (
          <GameCard
            key={game.id}
            game={game}
            onMakePick={onMakePick}
            showPickControls={game.status === "scheduled"}
            userPick={userPicks[game.id]}
          />
        ))}
      </div>
    </>
  );
};

export default GamesList;
